var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFavoriteFull = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/heart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2013 2.58325C12.693 2.58325 11.343 3.31659 10.5013 4.44159C9.65964 3.31659 8.30964 2.58325 6.8013 2.58325C4.24297 2.58325 2.16797 4.66659 2.16797 7.24159C2.16797 8.23325 2.3263 9.14992 2.6013 9.99992C3.91797 14.1666 7.9763 16.6583 9.98464 17.3416C10.268 17.4416 10.7346 17.4416 11.018 17.3416C13.0263 16.6583 17.0846 14.1666 18.4013 9.99992C18.6763 9.14992 18.8346 8.23325 18.8346 7.24159C18.8346 4.66659 16.7596 2.58325 14.2013 2.58325Z",
    fill: "#FF2727"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFavoriteFull, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/favorite-full.0fcd23c7.svg";
export { ForwardRef as ReactComponent };